// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import ContactsSection from "Content/Shared/Components/Sections/ContactsSection/ContactsSection"
import Footer from "Content/Shared/Layout/Footer/Footer"

import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { GlobalStyles, iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const ContactsScreen: React.FC<PropsType> = () => {
  return (
    <Wrapper>
      <ContactsSection />
      <Footer />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: ${GlobalStyles.insets.pageTop + 90}px;

  @media (max-width: ${iPhoneResolution}px) {
    margin-top: ${GlobalStyles.insets.pageTopMobile + 70}px;
  }
`

export default React.memo(ContactsScreen, memoComparison)
